import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import ReactPlayer from 'react-player'

import Waypoint from 'react-waypoint';
import styled from "react-emotion";

const Revealable = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  margin-top: ${({ show }) => (show ? "0" : "100px")};
  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;`;

class Reveal extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <Revealable show={this.state.revealed}>
          {this.props.children}
        </Revealable>
      </Waypoint>
    );
  }
}

const SlidingUp = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  transform: ${({ show }) => (show ? "translate(0,100px)" : "translate(0,0)")};
  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;`;

class SlideUp extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <SlidingUp show={this.state.revealed}>
          {this.props.children}
        </SlidingUp>
      </Waypoint>
    );
  }
}

const HeavenlyRitualPage = () => (
    <section>
    <Helmet title="Celebrating Mastery" />
                  <div className="mastery-nav">
                    <Link to="/celebrating-mastery" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_passion.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">PASSION</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-tenacity" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_tenacity.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">TENACITY</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-pioneering" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PIONEERING</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-patience" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PATIENCE</span></span></Link> 
                    <Link to="/celebrating-mastery/heavenly-ritual" className="mastery-nav-link allegre active"><img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">RITUAL</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-details" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">DETAILS</span></span></Link>  
                  </div>
          {/*RITUAL*/}
          <div className="mastery-block">
              <div className="mastery-block-header">
                <div className="grid-xl container">
                  <div className="columns">
                    <div className="column col-4 col-sm-12"><img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} /></div>
                    <div className="column col-6 col-sm-12">
                      <h1 className="allegre">HEAVENLY <span className="red">RITUAL</span></h1>
                      <h4>すべての道は天に通ず</h4>
                       <p>このゴールデン・エールを正しく味わうには、忍耐と正確さを要する儀式が必要だ。まず、清潔かつ乾いたデュベルグラスを室温にしておくこと。注ぐ時は45°に傾け、豊かな泡が蓋をするようゆっくり立てていく。ボトルにはビールを1cm残し、瓶底の酵母をビールに入れるか選ぶこと。すべてを成し遂げた時、天国の門は開かれる。</p>
                    </div>
                  </div>
                </div>
            </div>
            <div className="mastery-block-body relative">
               <img className="mastery-big-d" src={require('../../images/D_logo.png')} />
            <div className="grid-xl container">
                  <div className="columns">
                      <div className="column col-6 col-md-12">
                      <div className="mastery-block-text"><h4 className="red">デュベルの正しい味わい方</h4>
                       <p>1. 清潔なグラスを用意。埃、水滴、指紋などがつかないよう注意すること。この時、必ずグラスは乾いていること。濡れているとデュベルの特徴的な豊かな泡が立ちにくい。</p>
                       <p>2. 注ぐ時は、よく見えるようボトルとグラスを目の高さに持つ。45°に傾けたグラスの内側の壁に、ゆっくりと注いでいくこと。ボトルの半分まで注げたら、徐々にグラスを立てていく。そのままゆっくり注いでいくと、泡が形づくられるのを確認できる。</p>
                       <p>3. ボトルは中身を注ぎ切らないこと。 ビールは1cm分ボトルに残す。底に残るのは酵母で、これを入れるとビールが濁ってしまう。</p>
                       <p>4. グラスのロゴ半分までビールが注がれ、グラスの縁から1cm下まで泡がきたら完璧。</p>
                       <p>5. 酵母を瓶底に留めておくため、ボトルは立てた状態で冷蔵する。逆さにして保存すると注ぐ際に酵母が混ざってしまう。</p>
                      </div>
                      <div className="video-wrapper">
        <ReactPlayer 
          className='react-player'
          url='https://www.youtube.com/watch?v=fTVvuBaSku8'
          width='90%'
          height='90%'
        />
      </div> 
                      </div>
                      <div className="column col-6 col-md-12">
                        <img className="img-responsive img-90" src={require('../../images/_stories/_ritual/ritual_duvel_glass.jpg')} />
                    </div>
                    <div className="mastery-block-img-footer">                                                     
                    <img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} />
                  </div></div>
             </div>
            </div>
        </div>
    </section>
  
)

export default HeavenlyRitualPage



// WEBPACK FOOTER //
// ./src/pages/celebrating-mastery/heavenly-ritual.js